import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'app-estadisticas-cultivo',
    templateUrl: './estadisticas-cultivo.component.html'
})
export class EstadisticasCultivoComponent implements OnInit {

    public estadisticas;
    public tipoEstadisticas = 1;
    public gridModal = false;
    public gridTitle;
    public parentDataGrid;
    public dataCultivos;

    @Input() graficasCultivos;
    @Input() filtrado;
    @Input() allDataCultivos; // disponer, para cada tabla, de todas las propiedades agrupadas en objetos, y no en arrays separados

    @Output() showWarning = new EventEmitter<any>(true);

    constructor(
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allDataCultivos']) {
            if (changes['allDataCultivos'].currentValue) {
                this.dataCultivos = changes['allDataCultivos'].currentValue;
            }
        }
    }

    ngOnInit() {
        this.showCultivosPais();
    }

    public async showCultivosPais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 1;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab1: true
        });
    }

    public async showCultivosDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 2;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab2: true
        });
    }

    public async showCultivosCampanya() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 3;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab3: true
        });
    }

    public async showAforosPais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 4;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab41: true
        });
    }

    public async showAforosDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 5;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab5: true
        });
    }
    public async showAforosCampanyas() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 6;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab6: true
        });
    }

    public async showSuperficiePais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 7;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab7: true
        });
    }

    public async showSuperficieDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 8;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab8: true
        });
    }

    public async showSuperficieCampanyas() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 9;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab9: true
        });
    }

    public delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    public showGrid(title: string, gridArray: Array<any>, roundPercentage: string) {
        this.gridTitle = title;
        
        // Filtrado de valores 0
        const filteredGridArray = gridArray.filter(object => {
            if (object.numCultivos) {
                return object.numCultivos > 0;
            } else if (object.sumAforos) {
                return object.sumAforos > 0;
            } else if (object.sumSuperficies) {
                return object.sumSuperficies > 0;
            }
        })

        // Redondeo de los porcentajes para que coincidan con los mostrados en los donuts/barras
        if (roundPercentage === 'donut') {
            const percentagesAltered = filteredGridArray.map(obj => {
                return {
                    ...obj,
                    porcentajeCultivos: obj.porcentajeCultivos ? obj.porcentajeCultivos.toFixed(1) : null,
                    porcentajeAforo: obj.porcentajeAforo ? obj.porcentajeAforo.toFixed(1) : null,
                    porcentajeSuperficie: obj.porcentajeSuperficie ? obj.porcentajeSuperficie.toFixed(1) : null
                }
            })
            this.parentDataGrid = percentagesAltered;
        } else if (roundPercentage === 'bars') {
            const percentagesAltered = filteredGridArray.map(obj => {
                return {
                    ...obj,
                    porcentajeCultivos: obj.porcentajeCultivos ? Math.round(obj.porcentajeCultivos) : null,
                    porcentajeAforo: obj.porcentajeAforo ? Math.round(obj.porcentajeAforo) : null,
                    porcentajeSuperficie: obj.porcentajeSuperficie ? Math.round(obj.porcentajeSuperficie) : null
                }
            })
            this.parentDataGrid = percentagesAltered;
        }

        this.gridModal = true;
    }

    public hideModal() {
        this.gridModal = false;
    }
}